import { render, staticRenderFns } from "./FormBanner.vue?vue&type=template&id=54e90134"
import script from "./FormBanner.vue?vue&type=script&lang=js"
export * from "./FormBanner.vue?vue&type=script&lang=js"
import style0 from "./FormBanner.vue?vue&type=style&index=0&id=54e90134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports